import { render, staticRenderFns } from "./booking-consume-detail-dialog.vue?vue&type=template&id=4d0242c3&scoped=true"
import script from "./booking-consume-detail-dialog.vue?vue&type=script&lang=js"
export * from "./booking-consume-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./booking-consume-detail-dialog.vue?vue&type=style&index=0&id=4d0242c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0242c3",
  null
  
)

export default component.exports